var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeverageQuality(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 80,
    viewBox: "0 0 50 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8136 75.7323H28.571V50.894H24.3033V75.7323H14.0606C12.8657 75.7323 11.9268 76.6997 11.9268 77.8662C11.9268 79.0611 12.8941 80.0001 14.0606 80.0001H38.8421C40.037 80.0001 40.976 79.0327 40.976 77.8662C40.976 76.6712 40.0086 75.7323 38.8136 75.7323Z",
    fill: "url(#paint0_linear_1714_6171)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8136 75.7323H28.571V50.894H24.3033V75.7323H14.0606C12.8657 75.7323 11.9268 76.6997 11.9268 77.8662C11.9268 79.0611 12.8941 80.0001 14.0606 80.0001H38.8421C40.037 80.0001 40.976 79.0327 40.976 77.8662C40.976 76.6712 40.0086 75.7323 38.8136 75.7323Z",
    fill: "url(#paint1_radial_1714_6171)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8136 75.7323H28.571V50.894H24.3033V75.7323H14.0606C12.8657 75.7323 11.9268 76.6997 11.9268 77.8662C11.9268 79.0611 12.8941 80.0001 14.0606 80.0001H38.8421C40.037 80.0001 40.976 79.0327 40.976 77.8662C40.976 76.6712 40.0086 75.7323 38.8136 75.7323Z",
    fill: "url(#paint2_radial_1714_6171)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8136 75.7323H28.571V50.894H24.3033V75.7323H14.0606C12.8657 75.7323 11.9268 76.6997 11.9268 77.8662C11.9268 79.0611 12.8941 80.0001 14.0606 80.0001H38.8421C40.037 80.0001 40.976 79.0327 40.976 77.8662C40.976 76.6712 40.0086 75.7323 38.8136 75.7323Z",
    fill: "url(#paint3_radial_1714_6171)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8136 75.7323H28.571V50.894H24.3033V75.7323H14.0606C12.8657 75.7323 11.9268 76.6997 11.9268 77.8662C11.9268 79.0611 12.8941 80.0001 14.0606 80.0001H38.8421C40.037 80.0001 40.976 79.0327 40.976 77.8662C40.976 76.6712 40.0086 75.7323 38.8136 75.7323Z",
    fill: "url(#paint4_radial_1714_6171)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8136 75.7323H28.571V50.894H24.3033V75.7323H14.0606C12.8657 75.7323 11.9268 76.6997 11.9268 77.8662C11.9268 79.0611 12.8941 80.0001 14.0606 80.0001H38.8421C40.037 80.0001 40.976 79.0327 40.976 77.8662C40.976 76.6712 40.0086 75.7323 38.8136 75.7323Z",
    fill: "url(#paint5_radial_1714_6171)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8136 75.7323H28.571V50.894H24.3033V75.7323H14.0606C12.8657 75.7323 11.9268 76.6997 11.9268 77.8662C11.9268 79.0611 12.8941 80.0001 14.0606 80.0001H38.8421C40.037 80.0001 40.976 79.0327 40.976 77.8662C40.976 76.6712 40.0086 75.7323 38.8136 75.7323Z",
    fill: "url(#paint6_radial_1714_6171)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8136 75.7323H28.571V50.894H24.3033V75.7323H14.0606C12.8657 75.7323 11.9268 76.6997 11.9268 77.8662C11.9268 79.0611 12.8941 80.0001 14.0606 80.0001H38.8421C40.037 80.0001 40.976 79.0327 40.976 77.8662C40.976 76.6712 40.0086 75.7323 38.8136 75.7323Z",
    fill: "url(#paint7_linear_1714_6171)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.571 75.7322V62.1323H24.3032V75.7322C-5.96822 75.7322 51.6445 75.7322 28.571 75.7322Z",
    fill: "url(#paint8_linear_1714_6171)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4915 25.5149C20.531 25.5149 26.2379 19.8082 26.2379 12.7685C26.2379 5.72889 20.531 0.0221558 13.4915 0.0221558C6.45185 0.0221558 0.745117 5.72889 0.745117 12.7685C0.745117 19.8082 6.45185 25.5149 13.4915 25.5149Z",
    fill: "url(#paint9_linear_1714_6171)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4919 22.2144C18.7088 22.2144 22.9378 17.9853 22.9378 12.7684C22.9378 7.55157 18.7088 3.32245 13.4919 3.32245C8.27499 3.32245 4.0459 7.55157 4.0459 12.7684C4.0459 17.9853 8.27499 22.2144 13.4919 22.2144Z",
    fill: "url(#paint10_linear_1714_6171)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4919 22.2144C18.7088 22.2144 22.9378 17.9853 22.9378 12.7684C22.9378 7.55157 18.7088 3.32245 13.4919 3.32245C8.27499 3.32245 4.0459 7.55157 4.0459 12.7684C4.0459 17.9853 8.27499 22.2144 13.4919 22.2144Z",
    fill: "url(#paint11_radial_1714_6171)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9506 32.7986C43.9347 26.653 41.9431 20.1092 41.118 13.3661C40.9757 12.285 40.0937 11.4599 38.9841 11.4599H13.8897C12.7801 11.4599 11.8981 12.285 11.7558 13.3946C10.9876 20.0523 9.1098 26.5392 6.06547 32.5141C3.87469 36.8387 2.99268 41.96 4.01694 47.3374C5.72405 56.2713 12.8939 63.498 21.8562 65.2336C36.4804 68.0787 49.2552 56.9541 49.2552 42.8421C49.2552 39.2287 48.4301 35.8145 46.9506 32.7986Z",
    fill: "url(#paint12_linear_1714_6171)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7644 32.7593C42.9545 26.8135 41.0988 20.4823 40.3301 13.9585C40.1975 12.9125 39.3758 12.1142 38.3419 12.1142H14.9617C13.9277 12.1142 13.1061 12.9125 12.9735 13.986C12.2579 20.4272 10.5081 26.7034 7.67189 32.4839C5.63077 36.668 4.80899 41.6229 5.76329 46.8253C7.3538 55.4686 14.0339 62.4604 22.3839 64.1396C36.0091 66.8923 47.9113 56.1293 47.9113 42.4762C47.9113 38.9803 47.1426 35.6771 45.7644 32.7593Z",
    fill: "#ADE0FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5337 22.812H15.3982C14.3171 22.812 13.3782 23.5233 13.0652 24.576C12.0694 27.8764 10.789 31.0915 9.25265 34.1358C8.08613 36.4119 7.40329 38.8588 7.23258 41.391C6.83426 46.7684 8.65517 51.9181 12.3539 55.9298C16.0242 59.8846 21.1455 62.1323 26.4659 62.1323C26.8358 62.1323 27.2057 62.1323 27.5756 62.1038C37.7328 61.5063 45.6993 53.0562 45.6993 42.8705C45.6993 39.883 45.0449 37.0379 43.7361 34.3919C42.1713 31.2053 40.891 27.9333 39.8667 24.576C39.5537 23.5233 38.6148 22.812 37.5337 22.812Z",
    fill: "url(#paint13_linear_1714_6171)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5337 22.812H15.3982C14.3171 22.812 13.3782 23.5233 13.0652 24.576C12.0694 27.8764 10.789 31.0915 9.25265 34.1358C8.08613 36.4119 7.40329 38.8588 7.23258 41.391C6.83426 46.7684 8.65517 51.9181 12.3539 55.9298C16.0242 59.8846 21.1455 62.1323 26.4659 62.1323C26.8358 62.1323 27.2057 62.1323 27.5756 62.1038C37.7328 61.5063 45.6993 53.0562 45.6993 42.8705C45.6993 39.883 45.0449 37.0379 43.7361 34.3919C42.1713 31.2053 40.891 27.9333 39.8667 24.576C39.5537 23.5233 38.6148 22.812 37.5337 22.812Z",
    fill: "url(#paint14_radial_1714_6171)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5337 22.812H15.3982C14.3171 22.812 13.3782 23.5233 13.0652 24.576C12.0694 27.8764 10.789 31.0915 9.25265 34.1358C8.08613 36.4119 7.40329 38.8588 7.23258 41.391C6.83426 46.7684 8.65517 51.9181 12.3539 55.9298C16.0242 59.8846 21.1455 62.1323 26.4659 62.1323C26.8358 62.1323 27.2057 62.1323 27.5756 62.1038C37.7328 61.5063 45.6993 53.0562 45.6993 42.8705C45.6993 39.883 45.0449 37.0379 43.7361 34.3919C42.1713 31.2053 40.891 27.9333 39.8667 24.576C39.5537 23.5233 38.6148 22.812 37.5337 22.812Z",
    fill: "url(#paint15_radial_1714_6171)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5337 22.812H15.3982C14.3171 22.812 13.3782 23.5233 13.0652 24.576C12.0694 27.8764 10.789 31.0915 9.25265 34.1358C8.08613 36.4119 7.40329 38.8588 7.23258 41.391C6.83426 46.7684 8.65517 51.9181 12.3539 55.9298C16.0242 59.8846 21.1455 62.1323 26.4659 62.1323C26.8358 62.1323 27.2057 62.1323 27.5756 62.1038C37.7328 61.5063 45.6993 53.0562 45.6993 42.8705C45.6993 39.883 45.0449 37.0379 43.7361 34.3919C42.1713 31.2053 40.891 27.9333 39.8667 24.576C39.5537 23.5233 38.6148 22.812 37.5337 22.812Z",
    fill: "url(#paint16_radial_1714_6171)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6238 0.0283096C46.6238 0.0283096 38.9108 0 37.2435 0C35.5765 0 34.3429 0.922461 33.8649 2.27836C33.3872 3.63425 26.752 22.812 26.752 22.812H32.9758L38.8661 5.6902H46.6238V0.0283096Z",
    fill: "url(#paint17_linear_1714_6171)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6238 0.0283096C46.6238 0.0283096 38.9108 0 37.2435 0C35.5765 0 34.3429 0.922461 33.8649 2.27836C33.3872 3.63425 26.752 22.812 26.752 22.812H32.9758L38.8661 5.6902H46.6238V0.0283096Z",
    fill: "url(#paint18_radial_1714_6171)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6238 0.0283096C46.6238 0.0283096 38.9108 0 37.2435 0C35.5765 0 34.3429 0.922461 33.8649 2.27836C33.3872 3.63425 26.752 22.812 26.752 22.812H32.9758L38.8661 5.6902H46.6238V0.0283096Z",
    fill: "url(#paint19_radial_1714_6171)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6672 11.4998C28.7749 16.965 26.752 22.812 26.752 22.812H32.9758L36.8677 11.4998H30.6672Z",
    fill: "url(#paint20_linear_1714_6171)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6672 11.4998C28.7749 16.965 26.752 22.812 26.752 22.812H32.9758L36.8677 11.4998H30.6672Z",
    fill: "url(#paint21_linear_1714_6171)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6672 11.4998C28.7749 16.965 26.752 22.812 26.752 22.812H32.9758L36.8677 11.4998H30.6672Z",
    fill: "url(#paint22_radial_1714_6171)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6227 0C46.6227 0 40.7429 0 38.6551 0C36.567 0 36.4424 1.87824 36.4424 2.86739C36.4424 4.51224 38.1979 5.6902 38.8522 5.6902H46.6227V0Z",
    fill: "url(#paint23_linear_1714_6171)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2933 47.2155C44.4966 47.2155 43.8707 46.5895 43.8707 45.7929C43.8707 42.7486 43.1878 39.8465 41.8791 37.1436C38.977 31.2256 37.1276 25.0516 36.3594 18.7639C36.2741 17.9957 36.8147 17.2844 37.6113 17.1706C38.3226 17.0568 39.0908 17.6258 39.2046 18.4224C39.9159 24.3972 41.6799 30.2867 44.4397 35.8917C45.9477 38.9929 46.7159 42.3218 46.7159 45.7929C46.7159 46.5895 46.0899 47.2155 45.2933 47.2155Z",
    fill: "url(#paint24_linear_1714_6171)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5348 5.69034C47.4801 5.69034 48.2463 4.41652 48.2463 2.84517C48.2463 1.27383 47.4801 0 46.5348 0C45.5895 0 44.8232 1.27383 44.8232 2.84517C44.8232 4.41652 45.5895 5.69034 46.5348 5.69034Z",
    fill: "url(#paint25_radial_1714_6171)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4948 32.1856C24.7653 32.1856 25.7953 31.1556 25.7953 29.8851C25.7953 28.6146 24.7653 27.5847 23.4948 27.5847C22.2243 27.5847 21.1943 28.6146 21.1943 29.8851C21.1943 31.1556 22.2243 32.1856 23.4948 32.1856Z",
    fill: "url(#paint26_radial_1714_6171)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7868 39.6098C34.0573 39.6098 35.0872 38.5798 35.0872 37.3093C35.0872 36.0388 34.0573 35.0089 32.7868 35.0089C31.5163 35.0089 30.4863 36.0388 30.4863 37.3093C30.4863 38.5798 31.5163 39.6098 32.7868 39.6098Z",
    fill: "url(#paint27_radial_1714_6171)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4948 48.1897C24.7653 48.1897 25.7953 47.1597 25.7953 45.8892C25.7953 44.6187 24.7653 43.5888 23.4948 43.5888C22.2243 43.5888 21.1943 44.6187 21.1943 45.8892C21.1943 47.1597 22.2243 48.1897 23.4948 48.1897Z",
    fill: "url(#paint28_radial_1714_6171)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1714_6171",
    x1: 26.4514,
    y1: 75.9528,
    x2: 27.8768,
    y2: 85.3561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481106,
    stopColor: "#B2F1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4514 73.6411) rotate(92.7922) scale(20.2959 16.5943)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.710488,
    stopColor: "#BEDBF3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898158,
    stopColor: "#BBDAF5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9268 78.0867) rotate(69.4489) scale(9.68536 6.52108)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542632,
    stopColor: "#BADAF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.976 77.8198) rotate(94.4221) scale(4.01297 2.20024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFD8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BADAF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0651 77.1976) rotate(87.3975) scale(0.979035 8.62266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4FCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4388 78.798) rotate(90) scale(0.733522 7.20113)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9FFFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2163 76.6419) rotate(90) scale(0.933569 9.16506)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5E9FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1714_6171",
    x1: 26.4514,
    y1: 75.775,
    x2: 26.4514,
    y2: 76.3975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1714_6171",
    x1: 24.3066,
    y1: 69.4623,
    x2: 28.6634,
    y2: 69.4623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.100054,
    stopColor: "#AEDEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339641,
    stopColor: "#B1E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605271,
    stopColor: "#BCF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862565,
    stopColor: "#B5E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949027,
    stopColor: "#B0D3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1714_6171",
    x1: 13.4915,
    y1: 0.0221558,
    x2: 13.4915,
    y2: 25.5149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.565011,
    stopColor: "#25946A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B8963"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1714_6171",
    x1: 21.9065,
    y1: 7.84636,
    x2: 4.0459,
    y2: 16.9153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68C510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502235,
    stopColor: "#65C213"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60B43D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0592 18.5157) rotate(117.848) scale(10.659 8.1053)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CA153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#419F4B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1714_6171",
    x1: 26.4235,
    y1: 11.4599,
    x2: 26.4235,
    y2: 65.6805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CFEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146532,
    stopColor: "#A6C4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68111,
    stopColor: "#A9C4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93856,
    stopColor: "#B4E7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBECFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1714_6171",
    x1: 26.4335,
    y1: 62.1323,
    x2: 26.4335,
    y2: 22.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0510142,
    stopColor: "#E57476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281658,
    stopColor: "#F77B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521347,
    stopColor: "#FE8E34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969067,
    stopColor: "#FF9635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8C00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4881 25.4509) rotate(83.5006) scale(14.1389 12.6651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC70",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1702 29.5408) rotate(108.939) scale(19.1761 11.0724)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC70",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0885 35.5868) rotate(90) scale(10.4916 16.245)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB370",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1714_6171",
    x1: 31.4644,
    y1: 9.35794,
    x2: 37.0657,
    y2: 11.1584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D95575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208606,
    stopColor: "#E45580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360565,
    stopColor: "#E43A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788257,
    stopColor: "#F0427B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED4178"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.1552 2.1561) rotate(98.9726) scale(5.13076 4.46945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.630584,
    stopColor: "#DB3F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC3F50",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4883 5.53474) rotate(96.6544) scale(5.37089 2.3018)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2395B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E33E67",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1714_6171",
    x1: 28.4858,
    y1: 17.7156,
    x2: 34.1761,
    y2: 19.1382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD82AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237132,
    stopColor: "#ED78AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.420956,
    stopColor: "#F76FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674632,
    stopColor: "#FF74AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7EB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1714_6171",
    x1: 31.8098,
    y1: 11.4998,
    x2: 31.9979,
    y2: 13.5368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37277,
    stopColor: "#EE4B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788473,
    stopColor: "#F04C8C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.264 11.4998) rotate(90) scale(0.925583 2.26489)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E76895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E86C93",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1714_6171",
    x1: 40.8885,
    y1: 0,
    x2: 40.8885,
    y2: 5.69017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1515C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183599,
    stopColor: "#DF3A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35548,
    stopColor: "#DF4450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839869,
    stopColor: "#D5374E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE6B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1714_6171",
    x1: 38.2708,
    y1: 20.4994,
    x2: 45.6529,
    y2: 46.3366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.344387,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6461 3.31195) rotate(90) scale(3.15635 1.89875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169014,
    stopColor: "#D40F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B90712"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3062 29.1852) rotate(123.101) scale(3.5817)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFBA40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5982 36.6094) rotate(123.101) scale(3.5817)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799228,
    stopColor: "#FAC662"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1714_6171",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3062 45.1893) rotate(123.101) scale(3.5817)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784811,
    stopColor: "#F0BB49"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeverageQuality);
export default __webpack_public_path__ + "static/media/beverage_quality.e21a01a3ec92485d8484a6dd1d7d3afe.svg";
export { ForwardRef as ReactComponent };